import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BuildHealth } from 'src/app/models/build-health-models';
import { BuildHealthService } from 'src/app/services/build-health.service';
import { finalize } from 'rxjs/operators';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-build-health-report',
  templateUrl: './build-health-report.component.html',
  styleUrls: ['./build-health-report.component.css']
})
export class BuildHealthReportComponent implements OnInit {

  @Output() loaded: EventEmitter<any> = new EventEmitter();

  buildHealthRecords: BuildHealth[] = [];
  isLoaded: boolean = false;
  displayedColumns: string[] = [
    'definitionName', 'history', 'lastBuild', 'requestedFor', 'startDate', 'finishDate', 'duration'
  ];

  constructor(
    private buildHealthService: BuildHealthService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
  }

  public clearReport() {
    this.isLoaded = false;
    this.buildHealthRecords = [];
  }

  public hideReport() {
    this.isLoaded = false;
  }

  loadReport(numberOfBuilds: number, startDate: Date, endDate: Date): void {
    this.buildHealthService.getBuilds(numberOfBuilds, startDate, endDate)
      .source.pipe(finalize(() => {
        this.isLoaded = true;
        this.loaded.emit(null);
      }))
      .subscribe(response => {
        if (response && response.ok) {
          this.buildHealthRecords = response.body as BuildHealth[];
        } else if (response && !response.ok) {
          this.notificationService.showError(`Error loading build health: ${response.error}`)
          this.buildHealthRecords = [];
        } else {
          this.buildHealthRecords = [];
        }
      })
  }

  openLinkInNewTab(link: string): void {
    window.open(link, '_blank');
  }

  trackByBuildId(index: number, build: BuildHealth): number { 
    return build.latestBuild.id;
  }
}
